// extracted by mini-css-extract-plugin
export default {"meta":"ChatWindow_meta__bEQST","metaItem":"ChatWindow_metaItem__lGybG"};